module.exports = __webpack_public_path__ + "img/login-bg@2x.7e30840c.png";